<template lang="html">
    <fe-student-card v-show="activeStudent.show"
        :studentRecord="activeStudent.rec"
        :imageUrl="imageUrl"
        :modal="activeStudent.modal"
        @close="activeStudent.show = activeStudent.modal = false"
        fullNameField="student_full_name"
        schoolField="school_name"
        gradeField="grade_desc"
        :style="{
            position: 'absolute',
            left: `${left}px`,
            top: `${top}px`,
            padding: '1px 6px 1px 6px',
        }"
    >
        <!-- <code style="overflow:auto;max-height:200px;font-size:8px;">{{JSON.stringify(chips,null,2)}}</code> -->
        <template v-for="(item, chipIndex) in chips">
            <template v-if="item.type=='tag'">
                <fe-chip v-for="(tag, tagIndex) in item.filter" :key="chipKey(item, chipIndex) + '-tag-' + tagIndex + '-' + tag.value"
                    @mouseover="highlightedFilter=item.filterId" @mouseleave="highlightedFilter=null"
                >
                    <v-icon :color="tag.color">fas fa-tag</v-icon> {{tag.value}}
                </fe-chip>
            </template>

            <template v-else-if="['disability','ethnicity','gender','meal_status'].includes(item.type)">
                <fe-chip v-for="(tag, tagIndex) in getValidFilters(item)" :key="chipKey(item, chipIndex) + '-valid-' + tagIndex + '-' + tag.value"
                    @mouseover="highlightedFilter=item.filterId;log(item.filter,tag)" @mouseleave="highlightedFilter=null"
                >
                    {{tag.value}}
                </fe-chip>
            </template>

            <template v-else-if="!hasExtraValues(item)">
                <fe-chip v-for="(tag, tagIndex) in item.filter" :key="chipKey(item, chipIndex) + '-' + item.type + '-' + tagIndex + '-' + tag.value"
                    @mouseover="highlightedFilter=item.filterId" @mouseleave="highlightedFilter=null"
                >
                    {{ [tag.value, changeCase(item.type)].filter(Boolean).join(' : ') }}
                </fe-chip>
            </template>

            <fe-chip v-else
                :key="chipKey(item, chipIndex) + '-extra'"
                @mouseover="highlightedFilter=item.filterId" @mouseleave="highlightedFilter=null"
            >
                {{item.text}}
                <template #tooltip >
                    <!-- <v-list two-line dense dark> -->
                        <template v-for="filter in item.filter">
                            <v-list-item
                                v-for="(extraValue, key) in filter.extra_values"
                                :key="getComplexKey(key+extraValue,filter)"
                                dark dense
                            >
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ changeCase(key) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <span v-if="Array.isArray(extraValue)">
                                            <span v-for="(value, paramIndex) in extraValue" class="mr-1" :key="value.name">
                                                {{ `${value.name}${paramIndex < param.value.length - 1 ? ',' : ''}` }}
                                            </span>
                                        </span>
                                        <span v-else-if="isDecimalValue(extraValue)">
                                            {{ roundNumericValue(extraValue) }}
                                        </span>
                                        <span v-else>
                                            {{ extraValue  }}
                                        </span>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    <!-- </v-list> -->
                </template>
            </fe-chip>
        </template>

        <template #footer>
            <div @click="goToStudentProfile(activeStudent.rec.student_id)">
                <fe-btn>View Student Profile</fe-btn>
            </div>
        </template>
    </fe-student-card>
</template>

<script>
import { mapLocalState } from '@/util/vuexHelper'
import * as Util from '../Util'

export default {
    name: 'StudentCard',
    inject: ['localStore'],

    computed: {
        ...mapLocalState(['params','activeStudent','highlightedFilter']),
        chips() {
            return Util.studentFilterText(this, this.params.filters, this.activeStudent.rec)
        },
        left() {
            if(this.$el) {
                // Because the student card container has a fixed position, the parent, this.$el, no longer adjusts width, 
                // so we need to get the width of the student card container instead. 
                // Size of parent is 12 x 2 so we will keep this.$el.offsetWidth in the calculation.
                let offsetWidth = (this.$el.querySelector('.fe-student-card-container')?.getBoundingClientRect().width || 0) + this.$el.offsetWidth
                return Math.min(this.activeStudent.x + 15, this.$parent.$el.clientWidth - offsetWidth + 7)
            } else {
                return this.activeStudent.x + 15
            }
        },
        top() {
            if(this.$el) {
                // Because the student card container has a fixed position, the parent, this.$el, no longer adjusts height, 
                // so we need to get the height of the student card container instead.
                // Size of parent is 12 x 2 so we will keep this.$el.offsetHeight in the calculation.
                let offsetHeight = (this.$el.querySelector('.fe-student-card-container')?.getBoundingClientRect().height || 0) + this.$el.offsetHeight
    
                return this.activeStudent.y + offsetHeight + 40 < this.$parent.$el.clientHeight
                    ? this.activeStudent.y + 40 + this.voff : this.activeStudent.y - offsetHeight - 20 + this.voff
            } else {
                return this.activeStudent.y + 40 + this.voff
            }
        },
        voff() {
            return this.activeStudent.modal ? -48 : 0
        }
    },

    mounted() {
        this.throttleUrl = this.$_.throttle(this.setNewImageUrl,350)
    },

    watch: {
        activeStudent(v) {
            if(this.studentRec != v.rec) {
                // we are setting this here so computed chips is not always fired on just position changes
                this.studentRec = v.rec
            }

            this.throttleUrl(
                v.rec && v.rec.student_id
                    ? this.$axios.defaults.baseURL
                    + 'students.php?action=get&property=student_image&id='
                    + v.rec.student_id
                    : null
            )

        }
    },

    methods: {
        chipKey(item, chipIndex) {
            return item.filterId != null ? String(item.filterId) : `chip-${chipIndex}`
        },
        log(filter,tag) {},
        getComplexKey(key,filter) {
            if(filter.supporting.form_instance_created) key += filter.supporting.form_instance_created
            return key
        },
        getValidFilters(item) {
            return item.filter.filter(x => x.value)
        },
        changeCase(text) {
            return String(text) && text.includes('_') ? this.$_.startCase(text) : text
        },
        hasExtraValues(item) {
            return item.filter?.length && item.filter[0].extra_values
        },
        setNewImageUrl(v) {
            this.imageUrl = v
        },
        isDecimalValue(v) {
            return v && typeof v == 'string' && !isNaN(parseFloat(v)) && v.indexOf('.') > -1
        },
        roundNumericValue(v) {
            return this.$_.isBlank(v) ? null : (
                isNaN(v) || typeof v == 'boolean' ? String(v) : parseFloat(v).toFixed(2)
            )
        },
        goToStudentProfile(studentId) {
            this.$router.push({ path: `/StudentProfile/${studentId}` })
        },
    },

    data() {
        return {
            imageUrl: null,
            studentRec: null,
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
<style>
    .fe-student-card-container {
        position: fixed;
    }
</style>
